var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDownS16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.707 3.293a1 1 0 0 1 0 1.414L5.414 10H8a1 1 0 1 1 0 2H3.1A1.1 1.1 0 0 1 2 10.9V6a1 1 0 0 1 2 0v2.586l5.293-5.293a1 1 0 0 1 1.414 0",
  clipRule: "evenodd"
})));
export default SvgArrowDownS16;